
export enum PageMode {
  Stock = 0,
  Unlisted = 1,
  UnlistedMissingDeleted = 11,
  UnlistedDismantled = 12,
  UnlistedQC = 13,
  UnlistedNotLocated = 14,
  UnlistedNoImages = 15,
  UnlistedNoPrice = 16,
  UnlistedNoMpn = 17,
  UnlistedHasPrice = 18,
  UnlistedHasMpn = 19,
  UnlistedHasOeMpn = 191,
  Listed = 2,
  Orders = 3,
  OrdersPaid = 31,
  OrdersPicked = 32,
  OrdersShipped = 33,
  Exports = 4,
  ExportsPriced = 41,
  ExportsAccepted = 42,
  DeletedStock = 43,
  ScrapOutStock = 44,
  RecentlyListed = 5,
  RecentlyListedFailed = 51,
  RecentlyListedRestricted = 52,
}